export interface ToggleRefreshOptions {
  onSuccess?: (payload: ToggleRefreshAPIResponse) => void;
  onError?: (payload: { message: string }) => void;
}

export interface ToggleRefreshAPIResponse {
  code: Code;
  msg: string;
  path?: string;
  status?: boolean;
}

export const enum Code {
  Success = '100',
  Failure = '101',
  Redirect = '302',
}

type ApiError = Error & {
  response?: { status: number };
};

export function handleToggleRefresh({
  onSuccess,
  onError,
}: ToggleRefreshOptions) {
  return {
    onSuccess: ({ code, msg, path }: ToggleRefreshAPIResponse) => {
      if (code === Code.Redirect && path) {
        window.location.href = path;
        return;
      } else if (code === Code.Failure) {
        onError?.({ message: msg });
        return;
      }

      if (onSuccess) {
        onSuccess?.({ code, msg, path });
        return;
      }
      window.location.reload();
    },
    onError: (error: ApiError) => {
      console.log(error);
      const status = error.response?.status;
      switch (status) {
        case 405:
          onError?.({ message: '系統逾時，將為您更新頁面。' });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
          break;
        default:
          onError?.({ message: '' });
          break;
      }
    },
  };
}
